'use client';

import * as React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { doLogout } from '@/lib/actions/logout.action';
import { useOverlay } from '@/components/hooks/useOverlay';
import { CmsParams } from '@/lib/cms-params.type';
import { isAuthenticated } from '@/lib/helper/is-authenticated';
import UiHeaderButtons from '@/components/ui/HeaderButtons';
import Button from '@/components/ui/Button';

interface HeaderButtonsProps {
  cmsParams: CmsParams;
}

export function HeaderButtons({ cmsParams }: HeaderButtonsProps) {
  const client = useQueryClient();
  const { openOverlay } = useOverlay('mobile-menu');

  const handleLogout = async () => {
    try {
      await doLogout();
      client.clear();
      window.location.assign(window.location.origin);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <UiHeaderButtons>
      {isAuthenticated(cmsParams) ? (
        <React.Fragment>
          {/*<Button*/}
          {/*  key="deposit"*/}
          {/*  title="Deposit"*/}
          {/*  iconRight="plus-filled"*/}
          {/*  theme="primary"*/}
          {/*/>*/}
          <Button
            key="logout"
            title="Sign out"
            className="mobile-hide"
            onClick={handleLogout}
          />
          <Button
            key="menu"
            iconLeft="menu"
            onClick={openOverlay}
            theme="discrete"
            className="not-mobile-hide"
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Button
            key="menu"
            iconLeft="menu"
            onClick={openOverlay}
            theme="discrete"
            className="not-mobile-hide"
          />
        </React.Fragment>
      )}
    </UiHeaderButtons>
  );
}
